import * as locales from 'date-fns/locale';

export const getLocaleByCode = (langCode: string): {} | undefined => {
  if (langCode === 'en') {
    return locales['enUS'];
  }
  for (const locale in locales) {
    if (locales[locale].code === langCode) {
      return locales[locale];
    }
  }
};
